import { Pipe, PipeTransform } from '@angular/core';
import { ConfigurationObject, LssConfigurationEntity } from '../store/configuration.datamodel';
import { LssEntityStatus } from '../../deployments/store/deployment.datamodel';

/**
 * Checks if there are any changes in the configurations selected for some offices compared to current
 * office with configurations deployment
 */
@Pipe({
    name: 'hasConfigurationsChanged',
    standalone: false
})
export class HasConfigurationsChangedPipe implements PipeTransform {

  /**
   * Checks if the selected configurations are different from the current configurations for the selected entities
   * @param selectedConfigurations the new configurations selected
   * @param selectedEntities the entities for which the configurations are selected
   */
  transform(
    selectedConfigurations: { [key: string]: string },
    selectedEntities: LssConfigurationEntity[],
  ): boolean {
    if (Object.entries(selectedConfigurations).length === 0 || selectedEntities.length === 0) {
      return false;
    }

    return selectedEntities.some((entity: LssConfigurationEntity) => {
      const hasChangedDeployments = this.hasConfigurationChanged(entity.configurations ?? [], selectedConfigurations, false);
      const hasChangedOverrides = this.hasConfigurationChanged(entity.configurationOverrides ?? [], selectedConfigurations, true);
      const hasNewOverrides = entity.tag === LssEntityStatus.UNDEPLOYED && (entity.configurationOverrides ?? []).length === 0;
      return hasChangedDeployments || hasChangedOverrides || hasNewOverrides;
    });
  }

  /**
   * Checks if the configurations have changed compared to the selected configurations
   * @param configurations  the configurations to compare to
   * @param selectedConfigurations the potentially changed configurations
   * @param areConfigurationOverrides if the configurations are overrides
   * @private
   */
  private hasConfigurationChanged(
    configurations: (ConfigurationObject | undefined)[],
    selectedConfigurations: { [p: string]: string },
    areConfigurationOverrides: boolean
  ) {
    return configurations.some((config) => {
      const componentGuid = config?.componentId?.guid;
      if (!componentGuid) {
        return areConfigurationOverrides;
      }
      return selectedConfigurations[componentGuid] !== config.guid;
    });
  }
}
